<template>
  <div class="home">

    <fixedBtn></fixedBtn>

    <section class="map-wrapper" ref="map">
      <mapWorld></mapWorld>
    </section>

    <section ref="section2" class="section section2">

      <div class="section2__wrapper">
        <div class="section2__left">
          <p class="section2__left--title default js-scroll fade-in-bottom">
            Як захистити свою подорож від <span>інфекцій?</span>
          </p>
        </div>

        <div class="section2__right">

          <div class="section2__right--line1">

            <p class="section2__right--left default js-scroll fade-in-bottom">
              За кордоном можна зустріти не лише яскраві враження, гепатит&nbsp;А, жовту лихоманку, японський енцефаліт,
              черевний тиф…<br>
              В кожній країні поширені свої інфекції, до яких у вас немає імунітету.
            </p>

            <p class="section2__right--right default js-scroll fade-in-bottom">
              Через них
              <span>відпустка може перетворитись на лікарняний, або взагалі розділити життя на «до» та «після».</span>
            </p>

          </div>

          <div class="section2__right--line2 desk">

            <p class="section2__right--big  default js-scroll fade-in-bottom">Щеплення — надійний спосіб захисту від
              <span @click="scrollToTop();" onclick="gtag('event', 'click', {'event_category': 'інфекційних хвороб', 'event_label': 'головна сторінка desktop'})">інфекційних хвороб,</span></p>

            <p class="section2__right--small default js-scroll fade-in-bottom">що можуть очікувати на Вас в
              подорожі<sup>1</sup>.</p>

          </div>

        </div>
      </div>

      <div class="section2__right--line2 mobile">

        <p class="section2__right--big default js-scroll fade-in-bottom">Щеплення — надійний спосіб захисту від
          <span @click="scrollToTop();" onclick="gtag('event', 'click', {'event_category': 'інфекційних хвороб', 'event_label': 'головна сторінка mobile'})">інфекційних хвороб,</span></p>

        <p class="section2__right--small default js-scroll fade-in-bottom">що можуть очікувати на Вас в
          подорожі<sup>1</sup>.</p>

      </div>

    </section>

    <section ref="five-rules" class="section section3">

      <div class="section3__line line1 ">

        <div class="section3__line--item white default js-scroll fade-in-bottom">
          <p>
            На жаль, не всі екзотичні інфекції можна попередити вакцинацією, тому <span>запам’ятайте 5 правил,</span>
            що
            допоможуть зберегти Ваше здоров’я та навіть врятувати життя<sup>2</sup>.
          </p>
        </div>

        <div class=" section3__line--item two color1 js-scroll fade-in-bottom">
          <div class=" section3__line--icon default js-scroll fade-in-bottom">
            <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M54.7745 42.2253C53.2644 43.8653 51.0177 44.8064 48.6085 44.8064C46.1998 44.8064 43.9526 43.8653 42.4425 42.2253C42.4257 42.2074 42.4022 42.1982 42.3835 42.1824C42.3653 42.1661 42.3552 42.1457 42.3341 42.1316C42.3178 42.1203 42.2977 42.1174 42.2804 42.1074C42.2406 42.0845 42.2008 42.0674 42.1572 42.0525C42.1164 42.0383 42.0776 42.0262 42.0354 42.0191C41.9912 42.0116 41.9486 42.01 41.904 42.01C41.8608 42.01 41.82 42.0116 41.7779 42.0187C41.7342 42.0258 41.6935 42.0383 41.6517 42.0533C41.6095 42.0679 41.5702 42.0849 41.5314 42.107C41.5136 42.117 41.4935 42.1199 41.4767 42.1316C41.4556 42.1462 41.4455 42.1666 41.4273 42.1828C41.4091 42.1986 41.3851 42.2074 41.3688 42.2253C39.8587 43.8653 37.612 44.8064 35.2028 44.8064C32.7941 44.8064 30.5469 43.8653 29.0368 42.2253C29.02 42.2074 28.9965 42.1986 28.9783 42.1824C28.96 42.1661 28.95 42.1457 28.9289 42.1312C28.9121 42.1195 28.8919 42.1166 28.8742 42.1066C28.8349 42.0841 28.7956 42.067 28.7529 42.0525C28.7116 42.0383 28.6723 42.0258 28.6296 42.0187C28.5855 42.0112 28.5433 42.0096 28.4982 42.0096C28.4551 42.0096 28.4143 42.0112 28.3721 42.0183C28.3285 42.0254 28.2877 42.0379 28.246 42.0525C28.2033 42.0674 28.1645 42.0841 28.1257 42.1062C28.1084 42.1162 28.0878 42.1191 28.071 42.1307C28.0499 42.1453 28.0398 42.1657 28.0216 42.182C28.0034 42.1978 27.9794 42.2065 27.9631 42.2249C26.453 43.8649 24.2063 44.806 21.7971 44.806C19.3883 44.806 17.1412 43.8649 15.631 42.2249C15.6143 42.207 15.5908 42.1982 15.5721 42.182C15.5538 42.1657 15.5438 42.1453 15.5227 42.1312C15.5064 42.1195 15.4857 42.117 15.4685 42.107C15.4292 42.0845 15.3894 42.0674 15.3467 42.0525C15.3054 42.0383 15.2661 42.0258 15.2234 42.0187C15.1793 42.0112 15.1371 42.0096 15.0925 42.0096C15.0494 42.0096 15.0091 42.0112 14.9664 42.0183C14.9223 42.0254 14.8815 42.0379 14.8393 42.0529C14.7971 42.0674 14.7583 42.0845 14.7199 42.1062C14.7022 42.1162 14.6816 42.1191 14.6648 42.1307C14.6437 42.1453 14.6336 42.1661 14.6154 42.182C14.5972 42.1978 14.5732 42.2065 14.5569 42.2244C13.0468 43.8644 10.8001 44.8056 8.39085 44.8056C5.98212 44.8056 3.73494 43.8644 2.22483 42.2244C1.98842 41.9675 1.55492 41.9242 1.25855 42.1307C0.961712 42.3365 0.913283 42.7125 1.15066 42.9699C2.92311 44.8955 5.56153 46 8.39085 46C10.9502 46 13.3464 45.0892 15.094 43.4913C16.8414 45.0892 19.2377 46 21.7971 46C24.3564 46 26.7526 45.0892 28.5002 43.4913C30.2476 45.0892 32.6439 46 35.2033 46C37.7626 46 40.1589 45.0892 41.9064 43.4913C43.6533 45.0892 46.0501 46 48.6095 46C51.4388 46 54.0772 44.8956 55.8497 42.9699C56.0866 42.7129 56.0382 42.3369 55.7418 42.1307C55.4454 41.9254 55.0119 41.9683 54.7746 42.2253L54.7745 42.2253Z"
                  fill="black"/>
              <path
                  d="M54.775 50.2809C53.2654 52.331 51.0181 53.5075 48.6094 53.5075C46.2006 53.5075 43.9534 52.331 42.4432 50.2809C42.4264 50.258 42.4025 50.2471 42.3843 50.2268C42.366 50.207 42.356 50.1815 42.3353 50.1633C42.319 50.1492 42.2989 50.1456 42.2821 50.1336C42.2423 50.105 42.202 50.0831 42.1584 50.0643C42.1181 50.0466 42.0788 50.0315 42.0366 50.0227C41.9925 50.0133 41.9503 50.0112 41.9052 50.0112C41.862 50.0112 41.8208 50.0133 41.7781 50.0222C41.7345 50.031 41.6942 50.0466 41.6525 50.0649C41.6098 50.0836 41.5709 50.1044 41.5321 50.1325C41.5143 50.1456 41.4937 50.1492 41.4774 50.1638C41.4563 50.182 41.4462 50.2075 41.428 50.2278C41.4098 50.2476 41.3858 50.2585 41.3695 50.2814C39.8594 52.331 37.6123 53.5075 35.2034 53.5075C32.7946 53.5075 30.5474 52.331 29.0373 50.2809C29.0205 50.258 28.997 50.2471 28.9783 50.2273C28.9601 50.207 28.95 50.1815 28.9289 50.1638C28.9126 50.1492 28.892 50.1461 28.8747 50.1336C28.8354 50.1049 28.7956 50.0836 28.7524 50.0649C28.7116 50.0472 28.6723 50.0321 28.6296 50.0232C28.586 50.0138 28.5433 50.0118 28.4987 50.0118C28.4556 50.0118 28.4143 50.0138 28.3721 50.0227C28.3285 50.0315 28.2882 50.0472 28.2465 50.0654C28.2038 50.0841 28.1645 50.1049 28.1256 50.133C28.1084 50.1455 28.0878 50.1492 28.0715 50.1632C28.0508 50.1815 28.0408 50.207 28.0221 50.2273C28.0034 50.2471 27.9799 50.258 27.9631 50.2809C26.4529 52.331 24.2062 53.5075 21.7969 53.5075C19.3882 53.5075 17.141 52.331 15.6308 50.2809C15.614 50.258 15.5905 50.2471 15.5718 50.2273C15.5536 50.207 15.5435 50.1815 15.5229 50.1638C15.5066 50.1497 15.4865 50.1461 15.4692 50.1336C15.4299 50.1049 15.3896 50.0836 15.3464 50.0649C15.3057 50.0472 15.2664 50.0321 15.2237 50.0232C15.1796 50.0138 15.1374 50.0118 15.0928 50.0118C15.0496 50.0118 15.0088 50.0138 14.9662 50.0227C14.922 50.0315 14.8818 50.0472 14.8396 50.0659C14.7974 50.0841 14.7585 50.1055 14.7202 50.1331C14.7024 50.1455 14.6818 50.1492 14.665 50.1638C14.6439 50.182 14.6338 50.2075 14.6156 50.2278C14.5974 50.2476 14.5734 50.2585 14.5571 50.2809C13.047 52.331 10.7999 53.5075 8.39098 53.5075C5.98221 53.5075 3.73499 52.331 2.22486 50.2809C1.98843 49.9587 1.55493 49.9056 1.25856 50.1638C0.961711 50.4209 0.913281 50.891 1.15066 51.2127C2.92351 53.6195 5.56211 55 8.39098 55C10.9504 55 13.3466 53.8615 15.0942 51.864C16.8412 53.8615 19.238 55 21.7969 55C24.3564 55 26.7526 53.8615 28.5002 51.864C30.2476 53.8615 32.644 55 35.2034 55C37.7628 55 40.1591 53.8615 41.9066 51.864C43.6536 53.8615 46.05 55 48.6094 55C51.4387 55 54.0772 53.6195 55.8497 51.2122C56.0866 50.891 56.0382 50.4209 55.7418 50.1632C55.4459 49.9055 55.0124 49.9597 54.775 50.2809L54.775 50.2809Z"
                  fill="black"/>
              <path
                  d="M55.3108 36.6054H41.8482V26.433C47.2082 26.0717 51.4623 21.5474 51.4623 16.0224C51.4623 10.2625 46.8413 5.57682 41.161 5.57682C35.481 5.57682 30.8601 10.2626 30.8601 16.0229C30.8601 21.5475 35.1142 26.0723 40.4738 26.4335V36.6058L16.5257 36.6054V20.8567C21.8847 20.4954 26.1394 15.9706 26.1394 10.4461C26.1394 4.68576 21.5179 0 15.8381 0C10.1576 0 5.53619 4.68576 5.53619 10.4461C5.53619 15.9711 9.79031 20.4954 15.1503 20.8567V36.6054H1.68769C1.30788 36.6054 1 36.9171 1 37.3027C1 37.6878 1.3074 38 1.68769 38H55.3123C55.6921 38 56 37.6883 56 37.3027C55.9995 36.9171 55.6921 36.6054 55.3118 36.6054L55.3108 36.6054ZM32.2343 16.0229C32.2343 11.0323 36.2381 6.97143 41.1603 6.97143C46.0821 6.97143 50.0869 11.0323 50.0869 16.0229C50.0869 20.7786 46.4484 24.681 41.8476 25.0394V20.9635L46.2451 16.5044C46.5137 16.2321 46.5137 15.791 46.2451 15.5187C45.9766 15.2464 45.5416 15.2464 45.273 15.5187L41.8476 18.9921V13.0796C41.8476 12.6944 41.5402 12.3822 41.1599 12.3822C40.7801 12.3822 40.4722 12.6939 40.4722 13.0796V18.9921L37.0476 15.5192C36.7791 15.2469 36.3441 15.2469 36.0756 15.5192C35.807 15.7915 35.807 16.2326 36.0756 16.5049L40.4726 20.964V25.0399C35.8716 24.6815 32.2343 20.7788 32.2343 16.0229H32.2343ZM6.90995 10.4463C6.90995 5.4552 10.9147 1.39435 15.8365 1.39435C20.7582 1.39435 24.7625 5.4552 24.7625 10.4458C24.7625 15.2015 21.125 19.1039 16.5242 19.4623V15.3864L20.9212 10.9273C21.1898 10.655 21.1898 10.214 20.9212 9.94166C20.6527 9.66934 20.2177 9.66934 19.9492 9.94166L16.5246 13.4146V7.50199C16.5246 7.11686 16.2172 6.80467 15.8369 6.80467C15.4571 6.80467 15.1492 7.11637 15.1492 7.50199V13.4146L11.7237 9.94116C11.4552 9.66885 11.0202 9.66885 10.7517 9.94116C10.4831 10.2135 10.4831 10.6545 10.7517 10.9268L15.1492 15.3859V19.4618C10.5483 19.1044 6.90993 15.2015 6.90993 10.4463H6.90995Z"
                  fill="black"/>
            </svg>
            <p>Правило 1</p>
          </div>

          <p class=" section3__line--title default js-scroll fade-in-bottom">Ніколи не плавайте в брудній прісній
            воді<sup>2</sup>.</p>
          <p class=" section3__line--sentence default js-scroll fade-in-bottom">В ній може міститися багато збудників
            інфекцій, починаючи від
            кишкової
            палички та закінчуючи небезпечними лептоспірозом та шистосомозом<sup>2</sup>.</p>
        </div>

      </div>

      <div class="section3__line line2">

        <div class=" section3__line--item one color2 default js-scroll fade-in-bottom">
          <div class=" section3__line--icon js-scroll fade-in-bottom">
            <svg width="50" height="58" viewBox="0 0 50 58" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M3.75704 23.2013H1.8662C1.6365 23.2013 1.41586 23.2926 1.25327 23.4552C1.09127 23.6178 1 23.8384 1 24.0681V56.1333C1 56.363 1.09127 56.5836 1.25327 56.7462C1.41587 56.9088 1.63651 57.0001 1.8662 57.0001H26.2115C26.4412 57.0001 26.6618 56.9088 26.8244 56.7462C26.9864 56.5836 27.0777 56.363 27.0777 56.1333V24.0681C27.0777 23.8384 26.9864 23.6178 26.8244 23.4552C26.6618 23.2926 26.4412 23.2013 26.2115 23.2013H24.3219C24.1091 20.8082 23.0392 18.5723 21.3091 16.9051C19.5785 15.238 17.3045 14.2515 14.9054 14.1282V13.3266H16.4407C16.6704 13.3266 16.8904 13.2354 17.053 13.0728C17.2156 12.9102 17.3069 12.6901 17.3069 12.4598V7.65734C17.3069 7.42763 17.2156 7.207 17.053 7.04441C16.8904 6.88182 16.6698 6.79054 16.4401 6.79114H11.6376C11.4079 6.79054 11.1873 6.88181 11.0247 7.04441C10.8621 7.20701 10.7708 7.42765 10.7714 7.65734V12.4598C10.7708 12.6901 10.8621 12.9102 11.0247 13.0728C11.1873 13.2354 11.4079 13.3266 11.6376 13.3266H13.1718V14.1282C10.7726 14.2521 8.49864 15.238 6.76859 16.9051C5.03855 18.5721 3.96919 20.8082 3.75704 23.2013ZM12.5049 8.52347H15.5744V11.593L14.3074 11.5936C14.1358 11.5211 13.9423 11.5211 13.7701 11.5936H12.5049V8.52347ZM25.3451 48.1897H11.8726V32.048H25.3451V48.1897ZM25.3451 30.3146H11.0057C10.776 30.3146 10.5554 30.4059 10.3928 30.5685C10.2308 30.7311 10.1395 30.9517 10.1395 31.1814V49.0565C10.1395 49.2862 10.2308 49.5068 10.3928 49.6694C10.5554 49.832 10.776 49.9233 11.0057 49.9227H25.3451V55.2668H2.73295V24.9348H25.3451V30.3146ZM22.5862 23.2018H5.49311C5.70951 21.181 6.66518 19.3113 8.17576 17.9519C9.68694 16.5924 11.6467 15.8387 13.6794 15.8362H14.4011C16.4334 15.8387 18.3937 16.5924 19.9042 17.9519C21.4153 19.3114 22.3699 21.181 22.5862 23.2018Z"
                  fill="black" stroke="#DFBFBF" stroke-width="0.4"/>
              <path
                  d="M20.0268 11.3295H30.9677C31.4458 11.3295 31.8339 10.942 31.8339 10.4633C31.8339 9.9845 31.4458 9.59644 30.9677 9.59644H20.0268C19.5487 9.59644 19.1606 9.9845 19.1606 10.4633C19.1606 10.942 19.5486 11.3295 20.0268 11.3295Z"
                  fill="black" stroke="#DFBFBF" stroke-width="0.4"/>
              <path
                  d="M20.273 12.7344C19.8027 12.6474 19.3506 12.9587 19.2636 13.429C19.1765 13.8999 19.4878 14.352 19.9581 14.4384L30.7176 16.421V16.4216C30.7696 16.4313 30.8228 16.4361 30.876 16.4355C31.3239 16.4355 31.6975 16.094 31.738 15.6479C31.7791 15.2018 31.4726 14.798 31.0326 14.717L20.273 12.7344Z"
                  fill="black" stroke="#DFBFBF" stroke-width="0.4"/>
              <path
                  d="M20.1244 8.25298C20.1758 8.25298 20.2272 8.24875 20.2785 8.23968L31.0308 6.30537V6.30477C31.5011 6.21954 31.8142 5.76982 31.7296 5.29893C31.645 4.82804 31.1952 4.51493 30.7243 4.59896L19.9721 6.53327C19.5302 6.61245 19.2219 7.01564 19.2618 7.46294C19.3011 7.90964 19.6753 8.25238 20.1244 8.25299V8.25298Z"
                  fill="black" stroke="#DFBFBF" stroke-width="0.4"/>
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M36.3712 17.5727C36.4682 17.1984 36.8503 16.9737 37.2245 17.0708L40.4966 17.9192C40.8708 18.0163 41.0955 18.3983 40.9985 18.7725C40.9014 19.1467 40.5194 19.3714 40.1452 19.2744L36.8731 18.4259C36.4988 18.3289 36.2741 17.9469 36.3712 17.5727Z"
                    fill="black"/>
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M44.737 19.9629C44.8341 19.5887 45.2161 19.364 45.5903 19.461L48.8624 20.3095C49.2366 20.4065 49.4613 20.7886 49.3643 21.1628C49.2673 21.537 48.8852 21.7617 48.511 21.6647L45.2389 20.8162C44.8647 20.7192 44.64 20.3371 44.737 19.9629Z"
                    fill="black"/>
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M36.2525 10.931C36.2525 10.5444 36.5659 10.231 36.9525 10.231L40.3192 10.231C40.7058 10.231 41.0192 10.5444 41.0192 10.931C41.0192 11.3176 40.7058 11.631 40.3192 11.631L36.9525 11.631C36.5659 11.631 36.2525 11.3176 36.2525 10.931Z"
                    fill="black"/>
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M44.7146 11.1586C44.7146 10.772 45.028 10.4586 45.4146 10.4586L49 10.4586C49.3866 10.4586 49.7 10.772 49.7 11.1586C49.7 11.5452 49.3866 11.8586 49 11.8586L45.4146 11.8586C45.028 11.8586 44.7146 11.5452 44.7146 11.1586Z"
                    fill="black"/>
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M35.1758 4.76023C35.0793 4.38588 35.3045 4.00415 35.6789 3.9076L38.9521 3.06345C39.3264 2.96691 39.7082 3.19211 39.8047 3.56646C39.9012 3.94081 39.676 4.32255 39.3017 4.41909L36.0285 5.26325C35.6541 5.35979 35.2724 5.13458 35.1758 4.76023Z"
                    fill="black"/>
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M43.5417 3.2335C43.4451 2.85915 43.6704 2.47741 44.0447 2.38087L47.3179 1.53672C47.6923 1.44017 48.074 1.66538 48.1705 2.03973C48.2671 2.41408 48.0419 2.79582 47.6675 2.89236L44.3943 3.73651C44.02 3.83306 43.6382 3.60785 43.5417 3.2335Z"
                    fill="black"/>
            </svg>

            <p>Правило 2</p>
          </div>
          <p class=" section3__line--title js-scroll fade-in-bottom">Використовуйте спреї проти комах<sup>2</sup>.</p>
          <p class=" section3__line--sentence js-scroll fade-in-bottom">Москіти та мухи, що живляться кров’ю, шляхом
            укусу можуть інфікувати
            людину малярією, вірусом Денге, вірусом Зіка, лихоманкою чикунгунья, тощо<sup>2</sup>.</p>
        </div>

        <div class=" section3__line--item one color3 default js-scroll fade-in-bottom">
          <div class=" section3__line--icon js-scroll fade-in-bottom">
            <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_359_5406)">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M47.3653 8.10539C47.3653 10.4103 46.1405 12.1306 43.6904 13.2629C42.9907 13.5511 40.5298 14.2512 36.3093 15.3628C33.0975 16.2063 30.74 17.2563 29.2372 18.5126C27.94 19.6651 27.065 21.1269 26.6121 22.8981C26.3446 23.9076 26.2106 25.0915 26.2106 26.4494C26.2106 27.891 26.4161 29.2602 26.8284 30.5565C27.3226 31.9976 28.0123 33.2221 28.8977 34.2315C29.0214 34.3754 29.083 34.5296 29.083 34.6946C29.0628 34.8597 28.9904 34.9928 28.8667 35.0953C28.7431 35.1983 28.6199 35.2495 28.4962 35.2495C28.2907 35.2495 28.136 35.1879 28.0331 35.0643C27.0245 33.932 26.2421 32.5628 25.6859 30.9576C25.212 29.5363 24.9755 28.0344 24.9755 26.4481C24.9755 25.1103 25.1095 23.9057 25.377 22.8347L25.3154 22.742C24.801 21.6719 24.5434 20.7762 24.5434 20.0554C24.5434 19.3346 24.6769 18.5316 24.9449 17.6466C25.1504 16.8233 25.2538 16.1649 25.2538 15.6708C25.2538 14.8061 25.0582 13.8894 24.667 12.9221C24.3176 11.9958 23.8127 11.3156 23.1539 10.8839C23.01 10.8012 22.9273 10.6672 22.907 10.4823C22.8661 10.3173 22.8967 10.1631 22.9997 10.0192C23.0819 9.8753 23.2159 9.79258 23.4012 9.77233C23.5662 9.7314 23.7204 9.76199 23.8643 9.86496C24.7088 10.4828 25.3571 11.3474 25.81 12.4591C26.2426 13.5706 26.4584 14.6412 26.4584 15.6709C26.4584 16.3292 26.3554 17.0914 26.1495 17.9556C25.9026 18.7173 25.779 19.4174 25.779 20.0555C25.779 20.3437 25.8406 20.6836 25.9642 21.0744C26.5407 19.7156 27.3743 18.5627 28.4657 17.6148C30.1128 16.2147 32.6241 15.0621 36.0009 14.1562C40.1391 13.1062 42.5375 12.4268 43.1962 12.1179C45.1521 11.2533 46.1302 9.91462 46.1302 8.1035L45.914 7.05357C45.8523 6.78559 45.9243 6.56974 46.1302 6.40516C46.2952 6.23973 46.5115 6.20957 46.7786 6.31254C48.0138 6.88942 48.9298 7.65116 49.5274 8.5977C50.0831 9.46194 50.3718 10.43 50.392 11.5006C51.9572 11.7884 53.2127 12.6634 54.1596 14.1257C54.942 15.4018 55.3333 16.8223 55.3333 18.3867C55.3333 18.9222 55.1278 19.6528 54.7155 20.5792L54.5612 20.9195C55.014 21.063 55.3746 21.3413 55.6422 21.7532C55.889 22.2271 56.0127 22.9056 56.0127 23.7914C56.0127 24.1408 55.9403 24.6974 55.7964 25.4591C55.7762 25.6241 55.6935 25.7573 55.5496 25.8607C55.4057 25.9632 55.2514 25.9942 55.0864 25.9529C54.9214 25.9326 54.7883 25.8499 54.6849 25.7064C54.6026 25.5625 54.572 25.4083 54.5923 25.2433C54.7159 24.6462 54.7775 24.1623 54.7775 23.7914C54.7775 23.1943 54.7051 22.7104 54.5612 22.3399C54.4583 22.1547 54.1705 22.031 53.6966 21.9686H53.6655L50.5463 22.1228C48.4878 22.1228 46.9437 21.701 45.914 20.8566C44.6789 19.848 44.092 18.2315 44.1536 16.008C44.1536 15.8641 44.2153 15.7301 44.3389 15.6065C44.4626 15.4828 44.6065 15.4212 44.7715 15.4212C44.9365 15.4415 45.0804 15.5139 45.204 15.6375C45.3277 15.7612 45.3893 15.8951 45.3893 16.039C45.3277 17.8512 45.7598 19.1475 46.6865 19.9303C47.4689 20.5684 48.7451 20.8876 50.5158 20.8876L53.3572 20.7334L53.604 20.1156C53.9543 19.2922 54.1292 18.7154 54.1292 18.3862C54.1292 17.0475 53.8001 15.8438 53.1409 14.7727C52.2965 13.4962 51.1539 12.7655 49.7132 12.5802C49.5482 12.5591 49.4151 12.4876 49.3117 12.3635C49.2087 12.2399 49.1678 12.0955 49.188 11.931C49.229 10.9021 49.0028 10.0065 48.5086 9.24433C48.1997 8.79152 47.8089 8.38956 47.335 8.03971L47.3653 8.10539ZM37.0197 22.2174C38.6875 22.2174 40.1592 22.8352 41.4358 24.0704C41.8063 24.4198 42.1462 24.8222 42.4547 25.275L43.3193 25.6757C44.2866 26.191 44.9358 26.4478 45.265 26.4478C45.8208 26.4478 46.6855 25.8506 47.8591 24.6573C49.2593 23.2571 50.6793 22.5574 52.121 22.5574C52.5535 22.5574 52.8314 22.5776 52.9546 22.6199L53.1088 22.6815C53.2941 22.7431 53.572 22.9495 53.9425 23.2993C54.0662 23.4023 54.1381 23.5462 54.1588 23.7319C54.1588 23.8969 54.0972 24.0408 53.9735 24.1644C53.8706 24.2872 53.7267 24.3596 53.541 24.3807C53.376 24.3807 53.2321 24.3191 53.1084 24.1954L52.6453 23.824L52.1201 23.793C50.9667 23.793 49.8349 24.3699 48.7229 25.5224C47.3438 26.9438 46.1905 27.6533 45.2643 27.6533C44.8115 27.6533 44.1419 27.437 43.257 27.0049C43.4009 27.5607 43.4733 28.1888 43.4733 28.8885C43.4733 30.7208 43.2368 32.2033 42.7629 33.3355C42.351 34.3027 41.744 35.2398 40.9408 36.1458L42.4849 35.7451C43.226 35.5796 43.8851 35.4982 44.4616 35.4982C45.4086 35.4982 46.0674 35.7761 46.4383 36.3319C46.6851 36.7438 46.8088 37.4128 46.8088 38.3391C46.8088 38.586 46.7575 38.9461 46.6546 39.4201C46.5516 39.894 46.3564 40.5113 46.0678 41.2731C45.9648 41.5613 45.7899 41.7056 45.5426 41.7056H31.6457L31.4914 41.6746C26.9828 40.5631 23.8222 37.4439 22.0105 32.3174C21.6814 31.5557 21.4237 30.3416 21.2385 28.6738C21.0532 26.9234 20.8572 25.7606 20.6517 25.184C20.0339 22.9816 18.2119 21.8796 15.1857 21.8796C16.6681 22.2703 17.8413 23.0424 18.7064 24.1957C19.7766 25.5959 20.3122 27.4179 20.3122 29.6617C20.3122 32.3795 19.5402 34.603 17.996 36.3323C16.3697 38.1646 16.1462 39.081 13.3255 39.081C10.8552 39.081 10.7445 38.0625 8.99492 36.0238C7.30689 34.0683 6.39102 32.4212 6.2462 31.0825C6.1023 30.0942 6.02993 28.9831 6.02993 27.7479C6.02993 27.336 6.23544 27.1301 6.64775 27.1301C7.03851 27.1301 7.23454 27.3356 7.23454 27.7479C7.23454 29.0654 7.29615 30.1355 7.4198 30.9598C7.58481 32.0511 8.42837 33.4711 9.95224 35.2207C11.455 36.9703 11.2459 37.8458 13.3256 37.8458C15.7758 37.8458 15.7111 37.0634 17.1315 35.4987C18.449 33.9955 19.1082 32.0502 19.1082 29.6617C19.1082 27.7058 18.6653 26.1306 17.7804 24.9372C16.6481 23.4957 16.9498 22.7752 14.685 22.7752C14.1292 22.7752 13.738 22.7955 13.5113 22.8369L13.0482 23.1458C11.9569 23.9893 11.4114 25.0393 11.4114 26.2956C11.4114 27.1194 11.617 27.7057 12.0293 28.0565C12.585 28.5506 13.5734 28.7049 14.9938 28.5196C15.1588 28.4993 15.3131 28.5398 15.457 28.6432C15.5599 28.7458 15.622 28.8694 15.6422 29.0138C15.6836 29.1788 15.6422 29.333 15.5186 29.4769C15.4363 29.6006 15.3131 29.6721 15.1481 29.6932C13.3985 29.9401 12.0908 29.6932 11.2262 28.9526C10.5467 28.3554 10.2072 27.4701 10.2072 26.2961C10.2072 24.6494 10.9069 23.2802 12.3071 22.1894L13.0175 21.7263C14.1912 21.0055 13.5392 20.6453 15.0631 20.6453C18.7278 20.6453 20.9927 22.0455 21.8574 24.8451C22.0426 25.4831 22.2279 26.7085 22.4131 28.52C22.5984 30.0438 22.8349 31.1653 23.1236 31.8862C24.8116 36.5801 27.6736 39.4412 31.7088 40.4709H45.0807C45.2862 39.9768 45.4202 39.555 45.4823 39.2048L45.6059 38.3401C45.6059 37.6404 45.5443 37.1976 45.4207 37.0127C45.297 36.8279 44.9778 36.7348 44.4633 36.7348C43.9692 36.7348 43.4031 36.8064 42.765 36.9511L40.6342 37.4767H39.5843C39.4192 37.4767 39.2861 37.425 39.1827 37.3225C39.0591 37.1988 38.9975 37.0545 38.9975 36.8899V36.6737C38.9975 36.4875 39.0591 36.3333 39.1827 36.2105C40.3563 35.1403 41.1698 34.0378 41.6225 32.9056C42.0344 31.897 42.2403 30.5584 42.2403 28.8911C42.2403 27.8412 42.0038 26.9041 41.5299 26.0809C41.2417 25.6483 40.9328 25.2679 40.6036 24.9383C39.5739 23.9289 38.3801 23.4252 37.0213 23.4252C35.5388 23.4252 34.3347 23.8367 33.4079 24.6604C32.4816 25.4221 31.9254 26.3997 31.7401 27.5944C31.7199 27.7594 31.6475 27.8926 31.5238 27.9951C31.3799 28.1187 31.2257 28.1601 31.0607 28.1187C30.8957 28.0985 30.7725 28.0265 30.6902 27.9025C30.5872 27.7586 30.5463 27.6043 30.5665 27.4393C30.7315 25.9775 31.4209 24.7419 32.6359 23.7333C33.809 22.7225 35.2701 22.2174 37.0197 22.2174ZM5.53624 18.327C5.39234 18.224 5.31997 18.1004 5.31997 17.9556C5.29972 17.7906 5.34022 17.6364 5.44362 17.4925C7.48184 14.9196 8.13758 13.1381 11.411 12.1506C11.576 12.1092 11.7401 12.1303 11.9051 12.2122C12.049 12.2949 12.1417 12.4177 12.183 12.5836C12.224 12.7486 12.2033 12.9028 12.1214 13.0467C12.0391 13.2117 11.9159 13.3142 11.7509 13.3556C8.68298 14.2405 8.23371 15.867 6.40085 18.2343C6.27721 18.3782 6.11263 18.451 5.90669 18.451C5.76279 18.4506 5.63921 18.4084 5.53624 18.327ZM17.8111 8.44498C20.3435 9.24805 22.4538 11.0493 24.1417 13.8493C24.3067 14.2199 24.2343 14.5077 23.9254 14.7136C23.8431 14.7761 23.7402 14.8062 23.6165 14.8062C23.3899 14.8062 23.2046 14.7032 23.0607 14.4973C21.5783 11.9859 19.705 10.3389 17.4401 9.55607C17.2751 9.51514 17.1622 9.43242 17.1006 9.3092C17.0183 9.14419 17.008 8.98004 17.0696 8.81503C17.1105 8.65002 17.2135 8.53715 17.3785 8.47554C17.5232 8.39282 17.6672 8.38251 17.8111 8.44498ZM10.7011 10.6987C10.7834 10.5548 10.9066 10.4523 11.0716 10.3898C14.1598 9.44283 14.8776 9.55614 17.2247 10.7302C17.3897 10.7918 17.4923 10.9051 17.5336 11.0696C17.5952 11.2135 17.5849 11.3678 17.5026 11.5328C17.3996 11.7383 17.2148 11.8417 16.9468 11.8417C16.8232 11.8417 16.7413 11.8214 16.6999 11.7792C14.6001 10.7707 14.1603 10.6983 11.381 11.563C11.2371 11.6039 11.0928 11.594 10.9485 11.5319C10.8046 11.4492 10.7016 11.3256 10.6395 11.1606C10.5978 10.9968 10.6188 10.8426 10.7011 10.6987ZM8.50092 19.9013C6.68925 21.9396 5.57771 24.2557 5.16588 26.8498C5.14563 26.9937 5.08359 27.1178 4.98062 27.2203C4.85697 27.3233 4.72299 27.3746 4.57909 27.3746H4.51748C4.35247 27.3543 4.21935 27.272 4.11595 27.1281C4.01298 26.9842 3.97205 26.83 3.9923 26.665C4.40418 23.865 5.58769 21.3321 7.54362 19.0681C7.83142 18.7799 8.13041 18.7592 8.43932 19.0056C8.7073 19.2943 8.72754 19.5929 8.50092 19.9013Z"
                      fill="black"/>
                <path
                    d="M23.5497 48.5534C24.4008 47.2532 25.314 46.6383 26.7772 46.2543C27.5163 46.0603 28.2816 46.3943 28.7257 47.016L29.9816 48.7743C30.3115 49.2362 30.4297 49.8165 30.3065 50.3706L29.9339 52.0476C29.6942 53.1259 28.6259 53.8058 27.5476 53.5661L25.8637 53.1919C25.3136 53.0697 24.8406 52.7211 24.561 52.2318L23.543 50.4502C23.2046 49.8581 23.1762 49.1239 23.5497 48.5534Z"
                    stroke="black" stroke-width="1.2"/>
                <path d="M29 47.5C27.5 47.8333 24 49.9 24 51.5" stroke="black" stroke-width="1.2"/>
                <path d="M25 47L24.5 46" stroke="black" stroke-width="1.2" stroke-linecap="round"/>
                <path
                    d="M20.9503 50.5534C20.0992 49.2532 19.186 48.6383 17.7228 48.2543C16.9837 48.0603 16.2184 48.3943 15.7743 49.016L14.5184 50.7743C14.1885 51.2362 14.0703 51.8165 14.1935 52.3706L14.5661 54.0476C14.8058 55.1259 15.8741 55.8058 16.9524 55.5661L18.6363 55.1919C19.1864 55.0697 19.6594 54.7211 19.939 54.2318L20.957 52.4502C21.2954 51.8581 21.3238 51.1239 20.9503 50.5534Z"
                    stroke="black" stroke-width="1.2"/>
                <path d="M15.5 49.5C17 49.8333 20.5 51.9 20.5 53.5" stroke="black" stroke-width="1.2"/>
                <path d="M19.5 49L20 48" stroke="black" stroke-width="1.2" stroke-linecap="round"/>
              </g>
              <defs>
                <clipPath id="clip0_359_5406">
                  <rect width="56" height="56" fill="white"/>
                </clipPath>
              </defs>
            </svg>

            <p>Правило 3</p>
          </div>
          <p class=" section3__line--title js-scroll fade-in-bottom">Уникайте диких тварин<sup>2</sup>.</p>
          <p class=" section3__line--sentence js-scroll fade-in-bottom">Вражаючі селфі не варті ризику отримати укус
            та
            інфікування рани
            бактеріями. В гіршому випадку можливе навіть зараження вірусом сказу<sup>2</sup>.</p>
        </div>

        <div class=" section3__line--item one color4 default js-scroll fade-in-bottom">
          <div class=" section3__line--icon js-scroll fade-in-bottom">
            <img src="../assets/img/apple.svg" alt="">

            <p>Правило 4</p>
          </div>
          <p class=" section3__line--title js-scroll fade-in-bottom">Уникайте харчових отруєнь<sup>2</sup>.</p>
          <p class=" section3__line--sentence js-scroll fade-in-bottom">Для цього вживайте лише термічно оброблену
            їжу,
            а також ретельно мийте і
            очищуйте овочі та фрукти<sup>2</sup>.</p>
        </div>

        <div class=" section3__line--item tablet one color5 js-scroll fade-in-bottom">
          <div class=" section3__line--icon js-scroll fade-in-bottom">
            <svg width="56" height="57" viewBox="0 0 56 57" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M27.3999 52.4494H12.1583C11.3279 52.4494 10.6524 51.7791 10.6524 50.9552V49.0108C10.6524 48.1869 11.3279 47.5166 12.1583 47.5166H26.4182C26.7823 47.5166 27.0775 47.2237 27.0775 46.8624C27.0775 46.5011 26.7823 46.2082 26.4182 46.2082H12.1583C11.3279 46.2082 10.6524 45.5379 10.6524 44.714V42.7697C10.6524 41.9458 11.3279 41.2754 12.1583 41.2754H26.1723C26.5364 41.2754 26.8316 40.9825 26.8316 40.6213C26.8316 40.26 26.5364 39.9671 26.1723 39.9671H12.1583C11.3279 39.9671 10.6524 39.2968 10.6524 38.4729V36.5285C10.6524 35.7046 11.3279 35.0343 12.1583 35.0343H25.9264C26.2905 35.0343 26.5857 34.7414 26.5857 34.3801C26.5857 34.0188 26.2905 33.7259 25.9264 33.7259H12.1583C11.3279 33.7259 10.6524 33.0556 10.6524 32.2317V30.2874C10.6524 29.464 11.3271 28.794 12.1568 28.7932H12.1596H23.4594C23.8235 28.7932 24.1187 28.5003 24.1187 28.1391C24.1187 27.7778 23.8235 27.4849 23.4594 27.4849H12.3307C11.2923 26.8894 10.6524 25.7984 10.6524 24.6V18.4868C10.6524 18.1255 10.3572 17.8326 9.99309 17.8326C9.62899 17.8326 9.3338 18.1255 9.3338 18.4868V24.6C9.3338 25.8563 9.83829 27.029 10.7046 27.8856C9.88391 28.3765 9.3338 29.2693 9.3338 30.2875V32.2318C9.3338 33.0938 9.72823 33.8657 10.3471 34.3802C9.72823 34.8947 9.3338 35.6667 9.3338 36.5286V38.473C9.3338 39.3349 9.72823 40.1068 10.3471 40.6214C9.72823 41.1359 9.3338 41.9078 9.3338 42.7698V44.7141C9.3338 45.576 9.72823 46.348 10.3471 46.8625C9.72823 47.377 9.3338 48.149 9.3338 49.0109V50.9552C9.3338 52.5006 10.6009 53.7578 12.1583 53.7578H27.3999C27.764 53.7578 28.0592 53.4649 28.0592 53.1036C28.0592 52.7424 27.7641 52.4494 27.3999 52.4494Z"
                  fill="black"/>
              <path
                  d="M9.99345 16.3529C10.3576 16.3529 10.6527 16.06 10.6527 15.6988V14.3026C10.6527 13.0514 11.3482 11.9167 12.4678 11.3413L16.6442 9.1946C16.8629 9.08217 17.0002 8.85818 17.0002 8.61369V7.38942H24.2597V8.61369C24.2597 8.85809 24.397 9.08217 24.6157 9.1946L28.7922 11.3413C29.9117 11.9168 30.6072 13.0514 30.6072 14.3026V23.8619C30.6072 24.2232 30.9023 24.5161 31.2665 24.5161C31.6307 24.5161 31.9258 24.2232 31.9258 23.8619V14.3026C31.9258 12.5606 30.9574 10.9808 29.3986 10.1794L25.5783 8.21578V7.33194C26.5353 7.10874 27.2502 6.25508 27.2502 5.23832V2.37059C27.2501 1.18444 26.2777 0.219482 25.0822 0.219482H15.9245C14.7292 0.219482 13.7567 1.18444 13.7567 2.37059V5.23832C13.7567 6.34292 14.6002 7.25536 15.6816 7.37555V8.21578L11.8613 10.1794C10.3025 10.9807 9.33417 12.5606 9.33417 14.3026V15.6988C9.33417 16.06 9.62935 16.3529 9.99345 16.3529ZM15.0752 5.23832V2.37059C15.0752 1.90586 15.4562 1.52783 15.9245 1.52783H25.0822C25.5506 1.52783 25.9316 1.90586 25.9316 2.37059V5.23832C25.9316 5.70304 25.5506 6.08107 25.0822 6.08107H15.9245C15.4562 6.08107 15.0752 5.70304 15.0752 5.23832Z"
                  fill="black"/>
              <path
                  d="M51.6803 32.9366C51.463 32.7106 51.158 32.5809 50.8432 32.5809H32.1934C31.8786 32.5809 31.5736 32.7105 31.3564 32.9365C31.1392 33.1625 31.0231 33.4711 31.0381 33.7831L31.1854 36.8565C31.2027 37.2175 31.5113 37.4968 31.8753 37.4789C32.239 37.4617 32.5198 37.1553 32.5025 36.7943L32.3633 33.8893H50.6735L49.7802 52.5289C49.72 53.7819 48.6829 54.7633 47.4187 54.7633H35.6179C34.3539 54.7633 33.3166 53.7819 33.2565 52.5289L32.6361 39.5823C32.6188 39.2214 32.311 38.9442 31.9462 38.9599C31.5826 38.9771 31.3017 39.2835 31.319 39.6445L31.9395 52.5911C32.033 54.5428 33.6488 56.0717 35.618 56.0717H47.4188C49.3879 56.0717 51.0038 54.5428 51.0973 52.5911L51.9987 33.7831C52.0135 33.4712 51.8975 33.1626 51.6803 32.9366Z"
                  fill="black"/>
              <path
                  d="M36.9801 53.0529H46.0566C46.7567 53.0529 47.3312 52.5093 47.3644 51.8154L47.9472 39.655C47.9559 39.4762 47.8903 39.3019 47.7659 39.1724C47.6415 39.043 47.469 38.9697 47.2887 38.9697H35.7481C35.5678 38.9697 35.3954 39.043 35.2709 39.1724C35.1464 39.3019 35.081 39.4762 35.0895 39.655L35.6722 51.8154C35.7055 52.5093 36.28 53.0529 36.9801 53.0529ZM46.0479 51.7445H36.9889L36.7494 46.7452L37.9577 46.2781C39.0376 45.8607 40.2317 45.9521 41.2342 46.5289C42.0181 46.9799 42.909 47.209 43.8018 47.209C44.4543 47.209 45.1078 47.0866 45.7212 46.839L46.294 46.6078L46.0479 51.7445ZM46.5974 40.2781L46.363 45.1675L45.2243 45.627C44.1466 46.062 42.9023 45.976 41.8955 45.397C40.5442 44.6194 38.9342 44.4964 37.479 45.059L36.6833 45.3665L36.4394 40.278L46.5974 40.2781Z"
                  fill="black"/>
            </svg>

            <p>Правило 5</p>
          </div>
          <p class=" section3__line--title js-scroll fade-in-bottom">Пийте лише ту воду, в чистоті якої немає
            сумнівів<sup>2</sup>.</p>
          <p class=" section3__line--sentence js-scroll fade-in-bottom">Тобто із кулерів або із герметично закритих
            пляшок, уникайте
            водопровідної води та льоду<sup>2</sup>.</p>
        </div>

      </div>

      <div class="section3__line line3 default">

        <div class=" section3__line--item desk three color5 js-scroll fade-in-bottom">
          <div class=" section3__line--icon js-scroll fade-in-bottom">
            <svg width="56" height="57" viewBox="0 0 56 57" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M27.3999 52.4494H12.1583C11.3279 52.4494 10.6524 51.7791 10.6524 50.9552V49.0108C10.6524 48.1869 11.3279 47.5166 12.1583 47.5166H26.4182C26.7823 47.5166 27.0775 47.2237 27.0775 46.8624C27.0775 46.5011 26.7823 46.2082 26.4182 46.2082H12.1583C11.3279 46.2082 10.6524 45.5379 10.6524 44.714V42.7697C10.6524 41.9458 11.3279 41.2754 12.1583 41.2754H26.1723C26.5364 41.2754 26.8316 40.9825 26.8316 40.6213C26.8316 40.26 26.5364 39.9671 26.1723 39.9671H12.1583C11.3279 39.9671 10.6524 39.2968 10.6524 38.4729V36.5285C10.6524 35.7046 11.3279 35.0343 12.1583 35.0343H25.9264C26.2905 35.0343 26.5857 34.7414 26.5857 34.3801C26.5857 34.0188 26.2905 33.7259 25.9264 33.7259H12.1583C11.3279 33.7259 10.6524 33.0556 10.6524 32.2317V30.2874C10.6524 29.464 11.3271 28.794 12.1568 28.7932H12.1596H23.4594C23.8235 28.7932 24.1187 28.5003 24.1187 28.1391C24.1187 27.7778 23.8235 27.4849 23.4594 27.4849H12.3307C11.2923 26.8894 10.6524 25.7984 10.6524 24.6V18.4868C10.6524 18.1255 10.3572 17.8326 9.99309 17.8326C9.62899 17.8326 9.3338 18.1255 9.3338 18.4868V24.6C9.3338 25.8563 9.83829 27.029 10.7046 27.8856C9.88391 28.3765 9.3338 29.2693 9.3338 30.2875V32.2318C9.3338 33.0938 9.72823 33.8657 10.3471 34.3802C9.72823 34.8947 9.3338 35.6667 9.3338 36.5286V38.473C9.3338 39.3349 9.72823 40.1068 10.3471 40.6214C9.72823 41.1359 9.3338 41.9078 9.3338 42.7698V44.7141C9.3338 45.576 9.72823 46.348 10.3471 46.8625C9.72823 47.377 9.3338 48.149 9.3338 49.0109V50.9552C9.3338 52.5006 10.6009 53.7578 12.1583 53.7578H27.3999C27.764 53.7578 28.0592 53.4649 28.0592 53.1036C28.0592 52.7424 27.7641 52.4494 27.3999 52.4494Z"
                  fill="black"/>
              <path
                  d="M9.99345 16.3529C10.3576 16.3529 10.6527 16.06 10.6527 15.6988V14.3026C10.6527 13.0514 11.3482 11.9167 12.4678 11.3413L16.6442 9.1946C16.8629 9.08217 17.0002 8.85818 17.0002 8.61369V7.38942H24.2597V8.61369C24.2597 8.85809 24.397 9.08217 24.6157 9.1946L28.7922 11.3413C29.9117 11.9168 30.6072 13.0514 30.6072 14.3026V23.8619C30.6072 24.2232 30.9023 24.5161 31.2665 24.5161C31.6307 24.5161 31.9258 24.2232 31.9258 23.8619V14.3026C31.9258 12.5606 30.9574 10.9808 29.3986 10.1794L25.5783 8.21578V7.33194C26.5353 7.10874 27.2502 6.25508 27.2502 5.23832V2.37059C27.2501 1.18444 26.2777 0.219482 25.0822 0.219482H15.9245C14.7292 0.219482 13.7567 1.18444 13.7567 2.37059V5.23832C13.7567 6.34292 14.6002 7.25536 15.6816 7.37555V8.21578L11.8613 10.1794C10.3025 10.9807 9.33417 12.5606 9.33417 14.3026V15.6988C9.33417 16.06 9.62935 16.3529 9.99345 16.3529ZM15.0752 5.23832V2.37059C15.0752 1.90586 15.4562 1.52783 15.9245 1.52783H25.0822C25.5506 1.52783 25.9316 1.90586 25.9316 2.37059V5.23832C25.9316 5.70304 25.5506 6.08107 25.0822 6.08107H15.9245C15.4562 6.08107 15.0752 5.70304 15.0752 5.23832Z"
                  fill="black"/>
              <path
                  d="M51.6803 32.9366C51.463 32.7106 51.158 32.5809 50.8432 32.5809H32.1934C31.8786 32.5809 31.5736 32.7105 31.3564 32.9365C31.1392 33.1625 31.0231 33.4711 31.0381 33.7831L31.1854 36.8565C31.2027 37.2175 31.5113 37.4968 31.8753 37.4789C32.239 37.4617 32.5198 37.1553 32.5025 36.7943L32.3633 33.8893H50.6735L49.7802 52.5289C49.72 53.7819 48.6829 54.7633 47.4187 54.7633H35.6179C34.3539 54.7633 33.3166 53.7819 33.2565 52.5289L32.6361 39.5823C32.6188 39.2214 32.311 38.9442 31.9462 38.9599C31.5826 38.9771 31.3017 39.2835 31.319 39.6445L31.9395 52.5911C32.033 54.5428 33.6488 56.0717 35.618 56.0717H47.4188C49.3879 56.0717 51.0038 54.5428 51.0973 52.5911L51.9987 33.7831C52.0135 33.4712 51.8975 33.1626 51.6803 32.9366Z"
                  fill="black"/>
              <path
                  d="M36.9801 53.0529H46.0566C46.7567 53.0529 47.3312 52.5093 47.3644 51.8154L47.9472 39.655C47.9559 39.4762 47.8903 39.3019 47.7659 39.1724C47.6415 39.043 47.469 38.9697 47.2887 38.9697H35.7481C35.5678 38.9697 35.3954 39.043 35.2709 39.1724C35.1464 39.3019 35.081 39.4762 35.0895 39.655L35.6722 51.8154C35.7055 52.5093 36.28 53.0529 36.9801 53.0529ZM46.0479 51.7445H36.9889L36.7494 46.7452L37.9577 46.2781C39.0376 45.8607 40.2317 45.9521 41.2342 46.5289C42.0181 46.9799 42.909 47.209 43.8018 47.209C44.4543 47.209 45.1078 47.0866 45.7212 46.839L46.294 46.6078L46.0479 51.7445ZM46.5974 40.2781L46.363 45.1675L45.2243 45.627C44.1466 46.062 42.9023 45.976 41.8955 45.397C40.5442 44.6194 38.9342 44.4964 37.479 45.059L36.6833 45.3665L36.4394 40.278L46.5974 40.2781Z"
                  fill="black"/>
            </svg>

            <p>Правило 5</p>
          </div>
          <p class=" section3__line--title js-scroll fade-in-bottom">Пийте лише ту воду, в чистоті якої немає
            сумнівів<sup>2</sup>.</p>
          <p class=" section3__line--sentence js-scroll fade-in-bottom">Тобто із кулерів або із герметично закритих
            пляшок, уникайте
            водопровідної води та льоду<sup>2</sup>.</p>
        </div>

      </div>

    </section>

    <section class="section links">

      <div class="top-icon" @click="scrollToTop(); " onclick="gtag('event', 'click', {'event_category': 'на початок', 'event_label': 'головна сторінка'})">
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="24" cy="24" r="23.5" fill="white" stroke="#13575B"/>
          <path d="M24 16.0001V33.0001" stroke="#13575B" stroke-width="2"/>
          <path d="M32.5714 23.8571L24 16.0001L15.5 24.5001" stroke="#13575B" stroke-width="2"/>
        </svg>
      </div>

      <div class="links__title default">Посилання</div>

      <ol class="links__list">
        <li class="links__list--item default">Destinations. Traveler’s Health. CDC. <a target="_blank"
                                                                                       style="word-break: break-all"
                                                                                       href="https://wwwnc.cdc.gov/travel/destinations/list">https://wwwnc.cdc.gov/travel/destinations/list</a>
          (Дата доступу лютий 2024)
        </li>
        <li class="links__list--item default">Travel to the Extreme. Traveler’s Health. CDC. <a target="_blank"
                                                                                                style="word-break: break-all"
                                                                                                href="https://wwwnc.cdc.gov/travel/page/travel-to-the-extreme">https://wwwnc.cdc.gov/travel/page/travel-to-the-extreme</a>
          (Дата доступу лютий 2024)
        </li>
        <li class="links__list--item default">Pack smart. Traveler’s Health. CDC. <a target="_blank"
                                                                                     style="word-break: break-all"
                                                                                     href="https://wwwnc.cdc.gov/travel/page/pack-smart">https://wwwnc.cdc.gov/travel/page/pack-smart</a>
          (Дата доступу лютий 2024)
        </li>
      </ol>

    </section>

    <section class="section footer">

      <div class="footer__wrapper ">

        <div class="footer__col default">
          <p>NP-UA-ABX-WCNT-220002. Дата підготовки 8.02.2024
          </p>
          <p>Сайт призначено для користувачів, які знаходяться в Україні.
          </p>
          <p>Цей модуль сайту розроблено як інформаційний матеріал з просвітницькою метою. Для отримання більш детальної інформації про вакцинацію або захворювання зверніться до Вашого лікаря. Вакцинація можлива тільки на підставі рекомендацій Вашого лікаря. У матеріалах використано ілюстрації, які є гіпотетичними випадками і не передбачають, що зображені моделі зазнавали медичних втручань або страждали від захворювань.

          </p>
          <p>ТОВ «ГлаксоСмітКляйн Фармасьютікалс Україна» не володіє, не контролює та не несе відповідальності за зміст інформації на зовнішніх сайтах, на які Ви переходите за посиланнями.</p>
          <p>Copyright® Усі права на сайт www.vakcynacia.com.ua належать ТОВ «ГлаксоСмітКляйн Фармасьютікалс Україна».
          </p>
          <p>NP-UA-GVX-WCNT-220032. Дата підготовки 08.02.2024</p>
        </div>




      </div>
    </section>

  </div>
</template>

<script>
import mapWorld from '../components/map'
import fixedBtn from '../components/fixedBtn'

export default {
  name: 'HomeView',
  components: {
    mapWorld,
    fixedBtn
  },
  data: () => ({
    trigger25: true,
    trigger50: true,
    trigger75: true,
    trigger90: true,
  }),

  mounted() {
    if (window.matchMedia("(min-width: 1024px)").matches) {

      const scrollElements = document.querySelectorAll(".js-scroll");

      const elementInView = (el, dividend = 1) => {
        const elementTop = el.getBoundingClientRect().top;

        return (
            elementTop <=
            (window.innerHeight || document.documentElement.clientHeight) / dividend
        );
      };

      const elementOutofView = (el) => {
        const elementTop = el.getBoundingClientRect().top;

        return (
            elementTop > (window.innerHeight || document.documentElement.clientHeight)
        );
      };

      const displayScrollElement = (element) => {
        element.classList.add("scrolled");
      };

      const hideScrollElement = (element) => {
        element.classList.remove("scrolled");
      };

      const handleScrollAnimation = () => {
        scrollElements.forEach((el) => {
          if (elementInView(el, 1.1)) {
            displayScrollElement(el);
          } else if (elementOutofView(el)) {
            hideScrollElement(el)
          }
        })
      }

      window.addEventListener("scroll", () => {

        var h = document.documentElement,
            b = document.body,
            st = 'scrollTop',
            sh = 'scrollHeight';

        var percent = parseInt((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight) * 100);

        if (percent >= 25 && percent < 50 && this.trigger25) {
          this.trigger25 = false
          gtag('event', 'scroll', {'event_category': 'moreThan25%', 'event_label': 'Головна сторінка'})
        } else if (percent >= 50 && percent < 75 && this.trigger50) {
          this.trigger50 = false
          gtag('event', 'scroll', {'event_category': 'moreThan50%', 'event_label': "Головна сторінка"})
        } else if (percent >= 75 && percent < 90 && this.trigger75) {
          this.trigger75 = false
          gtag('event', 'scroll', {'event_category': 'moreThan75%', 'event_label': "Головна сторінка"})
        } else if (percent >= 90 && this.trigger90) {
          this.trigger90 = false
          gtag('event', 'scroll', {'event_category': 'moreThan90%', 'event_label': "Головна сторінка"})
        }

        handleScrollAnimation();
      });


    }
  },

  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }
}
</script>

<style lang="scss">
@import "../assets/style/fonts.css";
@import "../assets/style/vars";

.section {

  max-width: calc(1620px);
  width: 100%;
  margin: 0 auto;

  padding: 0 40px;

  @media screen and (max-width: 1440px) {
    //max-width: calc(1202px + 80px);
  }

  @media screen and (max-width: 620px) {
    padding: 0 20px;
  }
}

.default {
  cursor: default;
}

.section2 {
  display: flex;
  flex-direction: column;
  margin-top: 142px;
  background: white;

  &__wrapper {
    display: flex;
    justify-content: space-between;
  }

  &__left {
    width: 100%;
    max-width: calc(100% / 3);

    &--title {
      color: #6D6D6D;
      font-size: 48px;

      font-family: $medium;
      line-height: 56px;

      span {
        color: #000000;
      }
    }
  }

  &__right {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    max-width: calc((100% / 3) * 2);
    margin-left: 10px;

    @media screen and (max-width: 620px) {
      margin-left: 0;
    }


    &--left {
      max-width: 353px;
      width: 100%;
      margin-right: calc(57px / 2);

      color: #6D6D6D;
      font-size: 16px;
      font-family: $reg;
      line-height: 160%;
      padding-top: 9px;
    }

    &--right {
      margin-left: calc(57px / 2);
      max-width: 295px;
      width: 100%;

      color: #6D6D6D;
      font-size: 16px;
      font-family: $reg;
      line-height: 160%;
      padding-top: 4px;

      span {
        font-size: 20px;
        color: #000000;
        line-height: 160%;
        font-family: $medium;
      }
    }

    &--line1 {
      display: flex;
      justify-content: flex-start;
    }

    &--line2 {
      margin-top: 100px;

      &.mobile {
        display: none;
      }
    }

    &--big {
      color: #000000;
      font-size: 64px;
      font-family: $reg;
      line-height: 120%;

      span {
        cursor: pointer;
        color: #F36633;
        position: relative;
        display: inline-block;
        transition: all .2s ease;

        @media screen and (min-width: 1023px) {
          &:hover {
            color: #F36633;

            &:before {
              width: 10%;
            }
          }
        }

        &:active {
          color: #DE3B00;

          &:before {
            width: 10%;
          }
        }

        &:before {
          content: '';

          position: absolute;
          background: #F36633;
          width: 100%;
          height: 1px;
          left: 0;
          bottom: -2px;
          transition: all .2s ease;
        }
      }
    }

    &--small {
      font-size: 32px;
      line-height: 120%;
      font-family: $medium;
      color: #6D6D6D;
      margin-top: 18px;
    }
  }
}

.section3 {
  margin-top: 150px;

  &__line {

    display: flex;
    justify-content: space-between;

    margin: 0 -14px;

    &--item {
      margin: 14px;
      padding: 34.5px;
      border-radius: 24px;
      width: 100%;

      display: flex;
      flex-direction: column;

      &.tablet {
        display: none;
      }

      &.one {
        max-width: calc(100% / 3);
      }

      &.two {
        max-width: calc((100% / 3) * 2);
      }

      &.three {
        max-width: calc(100%);
      }

      &.white {
        background: white;
        padding: 0;
        justify-content: center;
        max-width: calc((100% / 3) - 28px);

        p {
          color: #6D6D6D;
          font-size: 20px;
          line-height: 130%;

          font-family: $reg;

          span {
            font-family: $semiBold;
            color: #000000;
          }
        }
      }

      &.color1 {
        background: #F6CABC;

        .section3__line--title {
          margin-bottom: 7px;
        }

        svg {
          max-width: 56px;
        }
      }

      &.color2 {
        background: #DFBFBF;

        svg {
          max-width: 50px;
        }
      }

      &.color3 {
        background: #E0E0A2;

        svg {
          max-width: 56px;
        }
      }

      &.color4 {
        background: #FFEFD1;

        img {
          max-width: 56px;
          width: 100%;
          height: auto;
          display: block;
          margin-right: 10px;
        }
      }

      &.color5 {
        background: #FFE5B6;

        .section3__line--title {
          margin-bottom: 7px;
        }

        svg {
          max-width: 56px;
        }
      }
    }

    &--icon {
      display: flex;
      align-items: center;
      margin-bottom: 13px;
      min-height: 58px;

      svg {
        width: 100%;
        height: auto;
        display: block;
        margin-right: 10px;
      }

      p {
        color: #544F40;
        font-size: 20px;
        line-height: 24px;
        font-family: $reg;
      }
    }

    &--title {
      color: #000000;

      font-size: 32px;
      line-height: 120%;
      font-family: $reg;
      margin-bottom: 15px;
    }

    &--sentence {
      color: #544F40;

      font-size: 16px;
      line-height: 160%;
      font-family: $reg;
    }
  }
}

.links {
  position: relative;
  margin-top: 100px;
  padding-top: 26px;

  .top-icon {
    position: absolute;
    right: 40px;
    top: 0;
    cursor: pointer;

    svg {
      width: 48px;
      height: auto;
      display: block;

      transition: all .2s ease;

      circle, path {
        transition: all .2s ease;
      }
    }

    @media screen and (min-width: 1023px) {
      &:hover {
        circle {
          fill: #A6E7EB;
        }
      }
    }

    &:active {
      circle {
        fill: #3E868A;
      }

      path {
        stroke: white;
      }
    }
  }

  &__title {
    color: #000000;
    font-size: 20px;
    line-height: 140%;
    font-family: $medium;
  }

  &__list {
    margin-top: 16px;
    list-style-type: decimal;
    padding-left: 20px;


    &--item {
      color: #6D6D6D;
      font-size: 14px;
      line-height: 160%;
      font-family: $reg;


      a {
        color: #6D6D6D;
        text-decoration: navajowhite;
        cursor: pointer;
      }
    }
  }
}

.footer {

  display: flex;
  justify-content: space-between;
  padding-top: 33px;
  padding-bottom: 40px;
  position: relative;
  margin-top: 30px;

  &:before {
    content: '';
    position: absolute;
    width: calc(100% - 80px);
    height: 1px;
    top: 0;
    left: 40px;
    background: #DFDFDF;
  }

  &__col {
    margin: 0 14px;

    max-width: 100%;
    width: 100%;

    p {
      margin-bottom: 10px;

      color: #6D6D6D;

      font-size: 12px;
      line-height: 160%;

      font-family: $reg;

      a {
        color: #F36633;
        font-size: 12px;
        line-height: 160%;
        font-family: $reg;
      }
    }
  }

  &__wrapper {
    margin: 0 -14px;

    display: flex;

    &.mob {
      display: none;
    }

    &.mob2 {
      display: none;
    }
  }
}

.js-scroll {
  opacity: 0;
  @media screen and (max-width: 1024px) {
    opacity: 1;
  }
}

.scrolled.fade-in {
  animation: fade-in 1s ease-in-out both;
  @media screen and (max-width: 1024px) {
    animation: none;

  }
}

.scrolled.fade-in-bottom {
  animation: fade-in-bottom 1s ease-in-out both;
  @media screen and (max-width: 1024px) {
    animation: none;
  }
}

.scrolled.slide-left {
  animation: slide-in-left 1s ease-in-out both;
  @media screen and (max-width: 1024px) {
    animation: none;

  }
}

.scrolled.slide-right {
  animation: slide-in-right 1s ease-in-out both;
  @media screen and (max-width: 1024px) {
    animation: none;

  }
}

@media screen and (max-width: 1200px) {

  .section2 {

    &__left {

      &--title {
        font-size: 40px;
        line-height: 48px;

        span {
          color: #000000;
        }
      }
    }

    &__right {
      display: flex;
      justify-content: flex-start;
      flex-direction: column;

      &--line2 {
        margin-top: 96px;

        &.mobile {
          display: none;
        }
      }

      &--big {
        font-size: 48px;
        line-height: 56px;
        max-width: 772px;
        width: 100%;
      }

      &--small {
        font-size: 26px;
        line-height: 120%;

      }
    }
  }

  .section3 {

    &__line {

      &--item {

        &.one {
        }

        &.two {
        }

        &.three {
        }

        &.white {

          p {
            span {
            }
          }
        }

        &.color1 {

          svg {
          }
        }

        &.color2 {

          svg {
          }
        }

        &.color3 {

          svg {
          }
        }

        &.color4 {

          svg {
          }
        }

        &.color5 {

          svg {
          }
        }
      }

      &--title {
        font-size: 26px;
        line-height: 120%;
      }
    }
  }

}

@media screen and (max-width: 1024px) {

  .section2 {
    margin-top: 56px;

    &__wrapper {
      justify-content: space-between;
    }

    &__left {
      max-width: 462px;
      width: 100%;
      margin-right: 10px;
    }

    &__right {
      max-width: 461px;
      width: 100%;

      &--left {
        margin-right: 0;
        max-width: 100%;
      }

      &--right {
        max-width: 100%;
        margin-top: 24px;
        margin-left: 0;
        padding-top: 0;
      }

      &--line1 {
        flex-direction: column;
        align-items: flex-end;
      }

      &--line2 {

        &.mobile {
          display: block;
        }

        &.desk {
          display: none;
        }
      }
    }
  }

  .section3 {
    margin-top: 88px;

    &__line.line1 {
      flex-direction: column;

      .section3__line--item {

        &:nth-child(1) {
          max-width: 600px !important;
          width: calc(100% - 20px);
        }

        &:nth-child(2) {
          max-width: calc(100% - 20px);
        }
      }
    }

    &__line.line2 {
      display: flex;
      flex-flow: row wrap;

      .section3__line--item {

        &:nth-child(1) {
          max-width: calc(50% - 20px);
        }

        &:nth-child(2) {
          max-width: calc(50% - 20px);
        }

        &:nth-child(3) {
          max-width: calc(50% - 20px);
        }

        &:nth-child(4) {
          max-width: calc(50% - 20px);
          display: block;
        }
      }
    }

    &__line.line3 {
      display: none;
    }

    &__line {
      margin: 0 -10px;

      &--item {
        padding: 24px 32px;
        margin: 10px;

        &.color5 {
          background: #FFE5B6;

          .section3__line--title {
            margin-bottom: 15px;
          }

        }

        &.color1 {

          .section3__line--title {
            margin-bottom: 15px;
          }

        }
      }
    }
  }

  .links {
    margin-top: 40px;
    padding-top: 30px;

  }

  .footer {

    &__col {
      max-width: 100%;
    }

    &__wrapper {

      &.desk {
        display: none;
      }

      &.mob {
        display: flex;
      }
    }
  }
}

@media screen and (max-width: 620px) {

  .section2 {
    margin-top: 48px;

    &__wrapper {
      flex-direction: column;
    }

    &__left {
      max-width: 100%;

      &--title {
        font-size: 32px;
        line-height: 120%;
      }
    }

    &__right {
      max-width: 100%;

      &--left {
        padding-top: 16px;
        font-size: 16px;
        line-height: 148%;
      }

      &--right {
        margin-top: 8px;
        font-size: 16px;
        line-height: 148%;
      }

      &--big {
        font-size: 32px;
        line-height: 120%;
        font-family: $medium;
      }

      &--small {
        margin-top: 8px;
        font-size: 20px;
        line-height: 140%;
      }

      &--line2 {
        margin-top: 64px;
      }
    }
  }

  .section3 {
    margin-top: 56px;

    &__line {
      margin: 0;

      &--item {
        padding: 20px 28px;
        margin: 8px 0;
        max-width: 100% !important;

        &.white {

          p {
            font-size: 16px;
            line-height: 148%;
          }
        }
      }

      &--icon {

        svg {
          max-width: 48px !important;
          width: 100%;
        }

        p {
          font-size: 16px;
          line-height: 148%;
        }
      }

      &--title {
        font-size: 20px;
        line-height: 140%;
        font-family: $medium;
      }

      &--sentence {
        font-size: 14px;
        line-height: 160%;
      }
    }
  }

  .links {
    margin-top: 40px;
    padding-top: 48px;

    .top-icon {
      right: 20px;
    }

    &__list {
      margin-top: 30px;
    }
  }

  .footer {
    padding-bottom: 20px;

    &:before {
      width: calc(100% - 40px);
      left: 20px;
    }

    &__col {
      margin: 0;
      max-width: 100%;
    }

    &__wrapper {
      margin: 0;
      flex-direction: column;

      &.mob {
        display: none;
      }

      &.mob2 {
        display: flex;
      }
    }
  }
}

@media screen and (max-width: 356px) {

  .section2 {

    &__right {

      &--big {
        font-size: 30px;
        line-height: 120%;
      }
    }
  }
}

@media screen and (max-width: 336px) {

  .section2 {

    &__right {

      &--big {
        font-size: 28px;
        line-height: 120%;
      }
    }
  }
}

@keyframes slide-in-left {
  0% {
    transform: translateX(-10px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slide-in-right {
  0% {
    transform: translateX(10px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes fade-in-bottom {
  0% {
    transform: translateY(30px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
{
  opacity: 0;
}

</style>
